import { useCallback, useState } from 'react';
import { useToggle } from '@direct-frontend/stdlib';
import { type Alias } from '#shared/api/schema';

export const useConstructorAddPageTemplate = (
    ModalComponent: React.ComponentType<{
        alias: Alias;
        onClose: () => void;
        isOpen: boolean;
    }>
) => {
    const [activeAlias, setActiveAlias] = useState<Alias>(undefined);
    const {
        value: isAddPageTemplateModalOpen,
        toggleOn: openAddPageTemplateModal,
        toggleOff: closeAddPageTemplateModal,
    } = useToggle(false);
    const addPageTemplate = useCallback(
        (alias: Alias) => {
            setActiveAlias(alias);
            openAddPageTemplateModal();
        },
        [openAddPageTemplateModal]
    );

    const renderAddPageTemplateModal = useCallback(() => {
        if (!activeAlias) {
            return null;
        }

        return (
            <ModalComponent
                alias={activeAlias}
                onClose={closeAddPageTemplateModal}
                isOpen={isAddPageTemplateModalOpen}
            />
        );
    }, [activeAlias, closeAddPageTemplateModal, isAddPageTemplateModalOpen, ModalComponent]);

    return {
        addPageTemplate,
        renderAddPageTemplateModal,
    };
};
